module.exports = __webpack_public_path__ + "img/basic2.c6a352a.png";